import { GeneratorControlWrapper } from './common'
import PatternButtons from './PatternButtons'
import { useContextPanels } from '../../contexts/panelsContext'
import { useEffect, useState } from 'react'
import { UIElement } from '../../types/UIElements'
import { useEnv } from '../../utils/useEnv'
import GeneratorTooltip from '../GeneratorTooltip'
import { cn } from '../../utils/cn'

const PatternButtonListControl = () => {
  const { panelState, isPanelOpen, isNothingOpen } = useContextPanels()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { isKiosk } = useEnv()

  useEffect(() => {
    if (isNothingOpen || isPanelOpen(UIElement.CONTROLS)) {
      setIsOpen(true)
    } else if (
      isKiosk &&
      isOpen &&
      !isPanelOpen(UIElement.SIDEMENU) &&
      !isPanelOpen(UIElement.EXPLANATION)
    ) {
      setIsOpen(false)
    }
  }, [panelState])

  return (
    <div
      className={cn(
        'fixed right-0 top-1/2 h-[200px] w-[110px] [transition:0.2s_ease-out] tall-xxs:h-[240px] tall-xxs:w-[130px] sm:h-[260px] sm:w-[140px] md:h-[320px] md:w-[175px] xl:h-[415px] xl:w-[220px]',
        { '[transform:translate(0,-50%)]': isOpen, '[transform:translate(100%,-50%)]': !isOpen },
      )}
    >
      <GeneratorTooltip />
      <GeneratorControlWrapper>
        <PatternButtons />
      </GeneratorControlWrapper>
    </div>
  )
}

export default PatternButtonListControl
